var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "new_course_editor" }, [
    _c("div", { staticClass: "new_course_editor_head" }, [
      _c(
        "span",
        { staticClass: "el-icon-arrow-left goback", on: { click: _vm.goback } },
        [_vm._v(" 返回")]
      ),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.courseName))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "login-user" },
        [
          _c(
            "el-dropdown",
            {
              attrs: { "show-timeout": 0 },
              on: { command: _vm.handleCommand }
            },
            [
              _c("div", { staticClass: "user-name el-dropdown-link" }, [
                _c("div", { staticClass: "imgBox" }, [
                  _c("img", { attrs: { src: _vm.imgUrl } })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "login-name" }, [
                  _vm._v(_vm._s(_vm.name))
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c("el-dropdown-item", { attrs: { command: "logOut" } }, [
                    _vm._v("退出")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "new_course_editor_bottom" }, [
      _c(
        "div",
        { staticClass: "new_course_editor_tree" },
        [
          _c("new-sidebar", {
            ref: "zlSidebar",
            attrs: { courseId: _vm.courseId, subjectId: _vm.subjectId },
            on: {
              setStatus: _vm.setStatus,
              openAddResoures: _vm.openAddResoures,
              emptyCatalogue: _vm.emptyCatalogue,
              handleTreeNodeClick: _vm.handleTreeNodeClick
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.zl_loading,
              expression: "zl_loading"
            }
          ],
          staticClass: "new_course_editor_content"
        },
        [
          _vm.status === 1
            ? _c("transition", { attrs: { name: "el-zoom-in-center" } }, [
                _c(
                  "div",
                  { staticClass: "new_course_editor_2" },
                  [
                    _c("add-resourse", {
                      attrs: {
                        editor: _vm.isEditor,
                        subjectId: _vm.subjectId,
                        data: _vm.resources,
                        catalogue: _vm.catalogue,
                        courseId: _vm.courseId,
                        refresh: _vm.refresh
                      }
                    })
                  ],
                  1
                )
              ])
            : _c("transition", { attrs: { name: "el-zoom-in-center" } }, [
                _c("div", { staticClass: "new_course_editor_3" }, [
                  _c("div", { staticClass: "new_course_editor_c" }, [
                    _c("img", {
                      staticStyle: {
                        width: "187px",
                        height: "159px",
                        "margin-bottom": "20px"
                      },
                      attrs: {
                        src: require("../../../src/assets/image/sources/table_no_data.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _vm.status === 0
                      ? _c("p", { staticStyle: { "text-align": "center" } }, [
                          _vm._v("一级目录下不能编辑内容")
                        ])
                      : _vm.status === 2
                      ? _c("p", { staticStyle: { "text-align": "center" } }, [
                          _vm._v("请 "),
                          _c(
                            "span",
                            {
                              staticClass: "new_course_editor_cc",
                              on: {
                                click: function($event) {
                                  return _vm.handleTreeNodeClick(
                                    _vm.catalogue,
                                    "add"
                                  )
                                }
                              }
                            },
                            [_vm._v("添加页面")]
                          ),
                          _vm._v(" 后编辑内容")
                        ])
                      : _vm.status === 3
                      ? _c("p", { staticStyle: { "text-align": "center" } }, [
                          _vm._v("请在末级目录下编辑内容")
                        ])
                      : _vm._e()
                  ])
                ])
              ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1af2ce8b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af2ce8b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/new_course_editor/index.vue
// module id = null
// module chunks = 